module.exports = __webpack_public_path__ + "img/Differentiation-BRCA_GSE176078.bfd46465.png";